﻿import Helpers from "./helpers";

declare var setCookie: any;

export default class Alert {

	private element = document.querySelector('.js-alert') as HTMLElement;
	private button: HTMLButtonElement;
	private expiration: Number;
	private cookieName: string;
	private hash: String;

	constructor() {

		if (!this.element) return;

		this.button = document.querySelector('.js-alert-button');
		this.expiration = parseInt(this.element.getAttribute('data-alert-cookie-expiration'));
		this.cookieName = this.getCookieName();
		this.hash = this.getHash();
		this.attachCloseEvent();

	}

	private attachCloseEvent() {
		this.button.addEventListener('click', (e) => this.handleButtonClick(e));
	}

	private handleButtonClick(e: Event) {

		setCookie(this.cookieName, this.hash, this.expiration);
		this.hideAlert();

		e.preventDefault();

	}

	private hideAlert() {

		this.element.addEventListener('transitionend', () => {
			Helpers.removeElement(this.element);
		});

		this.element.setAttribute('aria-expanded', 'false');
		this.element.setAttribute('aria-hidden', 'true');
		this.button.setAttribute('aria-expanded', 'false');
		this.button.setAttribute('aria-hidden', 'true');
	}

	private getHash() {

		return this.element.getAttribute('data-alert-cookie-content');

	}

	private getCookieName() {

		return this.element.getAttribute('data-alert-cookie-name');

	}

}
